import React, { useState, useEffect } from 'react';
import { MSG } from "../constants/toastMessages";
import { IoCloseOutline } from "react-icons/io5";
import { apiCallingPost } from "../api/services";
import { toast } from 'react-toastify';
import { MdDelete } from "react-icons/md";
import noData from "../assets/images/no-data.png";
import Loader from "../assets/images/loader.gif";
import { IoIosAdd } from "react-icons/io";

function GenerateTag(props) {
  const [tagNames, setTagNames] = useState([]);
  const [additionalTags, setAdditionalTags] = useState([]);
  const [newTag, setNewTag] = useState(""); // State for the new tag input
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [processedVideoList, setProcessedVideoList] = useState([]);

  useEffect(() => {
    proessedDetails();
  }, []);

  const proessedDetails = async () => {
    setLoading(true);
    let postData = {
      from_source: "",
      videoId: props.processedVideoId,
    };
    try {
      const response = await apiCallingPost("api/video/processedVideoDetails", postData);
      const { data } = response;
      setLoading(false);
      if (data.success === "1") {
        setProcessedVideoList(data.result);
      }
    } catch (error) {
      console.error("Error fetching video list:", error);
    }
  };

  const UpdateTag = (data, index) => {
    setNewTag("");
    setEditingRowIndex(index);
    let tagFilter = (data.tags?.split(/ \|\s*/) || []).filter(tag => tag.trim() !== "");
    setTagNames(tagFilter); // Initialize tagNames with existing tags
    let newtagFilter = (data.additional_tags?.split(/ \|\s*/) || []).filter(tag => tag.trim() !== "");
    setAdditionalTags(newtagFilter)
  };

  const handleTagChange = (event) => {
    setNewTag(event.target.value); // Update the new tag input value
  };

  const tagValidation = () => {
    if (tagNames.some((item) => item === newTag.trim())) {
      toast.error(MSG.tagExists);
      return false;
    }
    return true;
  };

  const addTag = () => {
    if (newTag.trim() === "") {
      toast.error(MSG.tagNameRequired);
      return false;
    }
    if (!tagValidation()) return;
    setTagNames([...tagNames, newTag.trim()]); // Add the new tag to the existing tags
    setAdditionalTags([...additionalTags, newTag.trim()]);
    setNewTag(""); // Clear the new tag input
  };

  const SaveTag = (dataList) => {
    if (!tagValidation()) return;

    let tagsList = [...tagNames, newTag.trim()].join(" | ");
    let newtagList = [...additionalTags, newTag.trim()].join(" | ");

    if (tagNames.some((tag) => tag.trim() === "")) {
      toast.error(MSG.fillAllFields);
      return;
    } else if (tagsList === dataList.tags) {
      toast.error(MSG.noChanges);
      return;
    }
    if (tagsList.split(" | ").length > 0) {
      const postData = {
        videoResultsId: dataList.videoResultsId,
        tag: tagsList,
        additionalTags: newtagList
      };
      apiCallingPost("api/video/addTag", postData)
        .then((data) => {
          setAdditionalTags([]);
          setEditingRowIndex(null);
          if (data.data.success === "1") {
            toast.success(MSG.tagUpdated);
            proessedDetails(dataList);
          }
        })
        .catch((error) => {
          console.error("Error adding tag:", error);
        });
    }
  };

  const removeTag = (tagToRemove) => {
    setTagNames(tagNames.filter(tag => tag !== tagToRemove));
    setAdditionalTags(additionalTags.filter(tag => tag !== tagToRemove));
  };

  return (
    <div className="modal-admin-wrapper">
     
      <div className="modal-ad-popup modal-lg">
        <div className="modal-innerpopup ">
          <div className="modal-headdiv d-flex justify-content-between">
            <h5 className="modal-head">Generate Tags </h5>
            <span className="closeBtn">
              <IoCloseOutline size={32} onClick={() => props.cancelPopup()} />
            </span>
          </div>
          <div className="modal-admin-body">
            {loading === false ? (
              processedVideoList.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered admin-list-table">
                    <thead>
                      <tr>
                        <th className="text-center">#</th>
                        <th style={{ minWidth: "200px" }}>Video Name</th>
                        <th style={{ minWidth: "200px" }}>Segment</th>
                        <th style={{ minWidth: "200px" }}>Video Description </th>
                        <th style={{ minWidth: "200px" }}>Tags</th>
                      </tr>
                    </thead>
                    <tbody>
                      {processedVideoList.map((data, i) => {
                       
                        return (
                          <tr key={i}>
                            <td className="text-center">{i + 1}</td>
                            <td>
                              {data.videoName}

                            </td>
                            <td >{data.file_type_id == 2 && (
                              <div >
                                {data.segmentDuration}
                              </div>
                            )}</td>
                            <td>
                              {data.description}</td>
                            <td style={{ Width: "200px" }}>
                              <div className="text-secondary tags-list">
                                {editingRowIndex === i ? (
                                  <>
                                    <div className="tagList">
                                      {tagNames.map((tag, index) => (
                                        <span className="tagSubList mb-2 me-1" key={index}>
                                          <span className="tagnames m-1">{tag}</span>
                                          <span className="delete-list-ico me-2">
                                            <MdDelete
                                              size={14}
                                              className="text-danger"
                                              onClick={() => removeTag(tag)}
                                            />
                                          </span>
                                        </span>
                                      ))}
                                      <span className="tagnames-input-outer">
                                        <input
                                          className="tagnames-input m-1"
                                          type="text"
                                          value={newTag}
                                          onChange={handleTagChange}
                                          placeholder="Enter new tag"
                                        />
                                      </span>
                                      <button type='submit' className="Add-btn-list" onClick={addTag}>
                                        <IoIosAdd className="me-2" />
                                        Add
                                      </button>
                                    </div>
                                    <div className="col-md-12 col-lg-12 col-12 px-0 text-center py-4">
                                      <input
                                        type="submit"
                                        value="Save"
                                        className="btn-save btn-small me-2"
                                        onClick={() => SaveTag(data)}
                                      />
                                      <input
                                        type="button"
                                        value="Cancel"
                                        className="btn-cancel btn-small"
                                        onClick={() => setEditingRowIndex(null)}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  (data.tags?.split(/ \|\s*/) || []).filter(tag => tag.trim() !== "").map((tag, index) => (
                                    <span key={index} className="tagnames m-1">
                                      {tag}
                                    </span>
                                  ))
                                )}
                                {(editingRowIndex !== i && !data.is_main) && (
                                  <div className="Add-btn-list" onClick={() => UpdateTag(data, i)}>
                                    <IoIosAdd className="me-2" />
                                    Edit
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="noData d-flex flex-column">
                  <div>
                    <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                  </div>
                  <div>No Data Available</div>
                </div>
              )
            ) : (
              <div className="noData d-flex flex-column">
                <div>
                  <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GenerateTag;